import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';

const BootstrapDialog = styled(Dialog)(({theme}) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
    '& .MuiPaper-root': {
        minWidth: "40vw"
    }
}));

const BootstrapDialogTitle = (props) => {
    const {children, onClose, ...other} = props;

    return (
        <DialogTitle sx={{m: 0, pt: 1, pb: 1, pl: 2, pr: 2, backgroundColor: '#363636', color: '#fefefe'}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    size={"small"}
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon fontSize={"small"} sx={{color: '#fefefe'}}/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

export default function FileExistConformation(props) {

    const handleClickOpen = () => {
        props.setOpen(true);
    };
    const handleClose = () => {
        props.setOpen(false);
    };
    const replace = () => {
        props.doUpload();
        handleClose();
    }
    const saveAsNew = () => {
        props.doUpload(true);
        handleClose();
    }
    return (
        <div>

            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="file-exist-dialog-title"
                open={props.open}
            >
                <BootstrapDialogTitle id="file-exist-dialog-title" onClose={handleClose}>
                    Warning!
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <Typography gutterBottom>
                        A file with the same name already exists in this location.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button style={{backgroundColor: "#8c3b61"}} variant="contained" size="small" color={"info"} autoFocus onClick={replace}>
                        Replace
                    </Button>
                    <Button style={{backgroundColor: "#8c3b61"}} variant="contained" size="small" color={"info"} autoFocus onClick={saveAsNew}>
                        Save as new
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </div>
    );
}
